import React, { useCallback, useEffect, useRef, useState } from "react";
import PulldownMenu from "components/Common/PulldownMenu";
import EditIcon from "images/icon/edit_16_on.svg";
import DeleteIcon from "images/icon/delete_16_on.svg";

interface Props {
  isShowMenu: boolean;
  onCloseMenu: () => void;
  onRequestEdit: () => void;
  onRequestDelete: () => void;
  onBlur?: () => void;
}

const HistoryActionsMenu: React.FC<Props> = ({
  isShowMenu,
  onCloseMenu,
  onRequestEdit,
  onRequestDelete,
  onBlur
}) => {
  const [pulldownDirection, setPulldownDirection] = useState<"down" | "up">(
    "down"
  );
  const historyRef = useRef<HTMLDivElement>(null);
  const PULLDOWN_THRESHOLD = 130;

  const updatePulldownDirection = useCallback(() => {
    if (!historyRef.current) return;

    const { bottom } = historyRef.current.getBoundingClientRect();
    setPulldownDirection(
      bottom > window.innerHeight - PULLDOWN_THRESHOLD ? "up" : "down"
    );
  }, []);

  useEffect(() => {
    if (!isShowMenu) return;
    updatePulldownDirection();

    window.addEventListener("scroll", updatePulldownDirection);
    window.addEventListener("resize", updatePulldownDirection);

    return () => {
      window.removeEventListener("scroll", updatePulldownDirection);
      window.removeEventListener("resize", updatePulldownDirection);
    };
  }, [isShowMenu, updatePulldownDirection]);

  return (
    <div ref={historyRef}>
      {isShowMenu && (
        <PulldownMenu
          list={[
            {
              label: "名前を変更",
              icon: <img src={EditIcon} alt="編集" />,
              key: "edit"
            },
            {
              label: "削除",
              icon: <img src={DeleteIcon} alt="削除" />,
              key: "delete"
            }
          ]}
          onClick={(key: string) => {
            if (key === "edit") {
              onRequestEdit();
            } else if (key === "delete") {
              onRequestDelete();
            }
            onCloseMenu();
          }}
          onOutsideClick={onCloseMenu}
          direction={pulldownDirection}
          onBlur={onBlur}
        />
      )}
    </div>
  );
};

export default HistoryActionsMenu;
